import { InfoLabel } from 'bold-ui'
import { useFlags } from 'config/useFlagsContext'
import React from 'react'
import { formatNumber } from 'util/number'

import { ExameQueryModel, ResultadoEspecificoPrimeiroBloco } from '../../model-resultadosExames'
import { getResultadoExameEspecificoProperties } from '../../util-resultadosExames'

interface ResultadoExameMarcadoresBioquimicosViewProps {
  value: ResultadoEspecificoPrimeiroBloco
  exame: ExameQueryModel
}

export const ResultadoExameMarcadoresBioquimicosView = (props: ResultadoExameMarcadoresBioquimicosViewProps) => {
  const { value, exame } = props

  const { PILOTO_CASA_DECIMAL_RESULTADO_EXAME_ENABLED } = useFlags()

  const { unit, precision = 0 } = getResultadoExameEspecificoProperties(
    exame,
    PILOTO_CASA_DECIMAL_RESULTADO_EXAME_ENABLED
  )

  return <InfoLabel title={`Resultado (${unit})`}>{formatNumber(value, precision)}</InfoLabel>
}
